import React from 'react'
import humanFormat from 'human-format'
import { t } from './../../jsCore/providers/i18nProvider/i18nProvider'

const NUMBERS_AFTER_FLOATING_POINT = 0

const formatNumber = number =>
  humanFormat(Number(number), { decimals: NUMBERS_AFTER_FLOATING_POINT })

const BLOCK_NAME = 'stat'
export const Stat = ({ amount, name }) => (
  <div className={BLOCK_NAME}>
    <h2 className={`${BLOCK_NAME}__amount`}>{formatNumber(amount)}</h2>
    {t(`stat_types.${name.toLowerCase()}`)}
  </div>
)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/user_stats/Stat.view.js